var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("vwc-button", {
    attrs: {
      label: _vm.label,
      appearance: "filled",
      layout: _vm.layout,
      disabled: _vm.isLeaving,
    },
    on: {
      click: function ($event) {
        return _vm.leaveMeeting(_vm.endForAll, _vm.stopRecordingFlag)
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }